import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetAccountRes, GetSessionsRes, SaveAccountReq, SaveAccountRes } from '../models';

export interface AccountApi {
  getAccount(): Observable<GetAccountRes>;
  saveAccount(params: SaveAccountReq): Observable<SaveAccountRes>;
  getSessions(): Observable<GetSessionsRes>;
}

export const ACCOUNT_API = new InjectionToken<AccountApi>('ACCOUNT_API');
